import { Box, Button, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import cookieFinanceLogo from "assets/home/cookie_finance_logo.png";

import { trackEvent } from "utils/tracking";

const FinanceCookie = () => {
  return (
    <Box
      sx={{
        p: 3,
        background:
          "linear-gradient(57.59deg, #151F16 -1.58%, #004537 98.35%), linear-gradient(180deg, rgba(236, 234, 229, 0) 0%, #ECEAE5 100%), #FFFFFF",
        borderRadius: 4,
      }}
    >
      <Grid
        container
        gap={2}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item xs>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 8,
              mb: 1,
              py: 1,
              px: 2,
              width: "max-content",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            <Box
              component="i"
              className="fa-solid fa-calculator"
              sx={{ mr: 0.5 }}
            />{" "}
            Partner offer
          </Box>
          <Typography
            variant="h4"
            sx={{ color: "yellow.main", fontWeight: 700, mb: 1 }}
          >
            Taxes & Bookkeeping for Creators
          </Typography>
          <Typography sx={{ color: "#ECEAE5", mb: 0.5, fontSize: 18 }}>
            Click below to get 50% off your first month with code{" "}
            <strong>BENTO50</strong>
          </Typography>
          <Typography sx={{ color: grey[200], mb: 2, fontSize: 14 }}>
            Simplify your finances with Cookie Finance. Work with accountants
            who know the creator economy.
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Box
            sx={{
              width: { xs: 80, md: 160 },
              py: 2,
              px: 2,
              borderRadius: 6,

              backgroundColor: "yellow.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              sx={{ width: "100%", height: "100%", objectFit: "contain" }}
              src={cookieFinanceLogo}
            />
          </Box>
        </Grid>
      </Grid>

      <Button
        variant="outlined"
        fullWidth
        href="https://info.cookiefinance.co/bento"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          trackEvent("Partner Offers View Offer Clicked", {
            Offer: "Cookie Finance",
          })
        }
        sx={{
          borderRadius: 2,
          py: 1,
          color: "white",
          borderColor: "white",
          "&:hover": {
            color: "yellow.main",
            borderColor: "yellow.main",
          },
        }}
      >
        Get 50% off with code BENTO50
      </Button>
    </Box>
  );
};

export default FinanceCookie;
